import {
  ORGANIZATION_FETCH,
  ORGANIZATION_FETCH_SUCCESS,
  ORGANIZATION_FETCH_FAIL,
  ORGANIZATION_SAVE,
  ORGANIZATION_SAVE_SUCCESS,
  ORGANIZATION_SAVE_FAIL
} from '../constants/ActionTypes';

const initialState = {
  data: {},
  loading: true,
  saving: false,
  error: null,
  errors: []
};

export default function(state = initialState, action) {
  switch (action.type) {
    case ORGANIZATION_FETCH:
      return {
        ...state,
        loading: true,
        error: null,
        errors: []
      };
    case ORGANIZATION_FETCH_SUCCESS:
      return {
        ...state,
        data: { ...action.organization },
        loading: false,
        error: null,
        errors: []
      };
    case ORGANIZATION_FETCH_FAIL:
      return {
        ...state,
        data: {},
        loading: false,
        errors: action.errors
      };
    case ORGANIZATION_SAVE:
      return {
        ...state,
        loading: true,
        saving: true,
        error: initialState.error,
        errors: initialState.errors
      };
    case ORGANIZATION_SAVE_SUCCESS:
      return {
        ...state,
        data: {...action.payload},
        loading: false,
        saving: false,
        error: initialState.error,
        errors: initialState.errors
      };
    case ORGANIZATION_SAVE_FAIL:
      return {
        ...state,
        loading: false,
        saving: false,
        ...action.payload
      };
    default:
      return state;
  }
}
